import React from "react";
import AlreadyInSystemField from "./AlreadyInSystemField";
import AddNewStudent from "./AddNewStudent";
import { serverIcon, studentIcon } from "../../assets/icons";
import SelectedField from "../../components/SelectedField";
import CardDetailUserLog from "./CardDetailUserLog";
import { Container } from "reactstrap";
import ButtonPrimary from "../../components/ButtonPrimary";
import { BiChevronLeft } from "react-icons/bi";
import { useHistory } from "react-router-dom";

export default function TrainImageFromActivities() {
  var history = useHistory();
  return (
    <Container fluid>
      <BiChevronLeft
        className="cursor-pointer"
        size={40}
        color="#bfbfbf"
        style={{ marginLeft: "-20px", marginBottom: "10px" }}
        onClick={() => history.push("/activities")}
      />

      <CardDetailUserLog />

      <div>
        <div className="row-jcct-py2">
          <p style={{ color: "#134e96" }} className="txt-main-content1">
            Add New Train Image data to Server
          </p>
        </div>

        <SelectedField
          listImage={[
            {
              title: "From Systems",
              image: serverIcon,
              page: <AlreadyInSystemField />,
            },
            {
              title: "New Student",
              image: studentIcon,
              page: <AddNewStudent />,
            },
          ]}
        />

        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="button-save-TrainImageFromActivities">
            <ButtonPrimary
              style={{ width: "100%" }}
              className={"primary-button"}
              text={"Save"}
            />
          </div>
        </div>
      </div>
    </Container>
  );
}